import { CardHeader, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import Icon from '@components/Icon/Icon';
import StackedIcon from '@components/Icon/StackedIcon';

import { getObservationConfig } from '@constants/fhir';

import { useDeleteAlertSetting } from '@hooks/api/alerts/alert_setting';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useSession } from '@hooks/useSession';

import type { AlertSettingModel } from 'generated/types';

const messages = defineMessages({
  delete: {
    id: 'alertSettingTable.delete',
    defaultMessage: 'Are you sure you want to delete this alert setting?',
  },
});

interface AlertSettingItemHeaderProps {
  setting: AlertSettingModel;
}

export default function AlertSettingItemHeader({
  setting,
}: AlertSettingItemHeaderProps) {
  const { formatMessage } = useIntl();
  const { flags } = useFeatureFlags();
  const {
    state: { activeProfile },
  } = useSession();
  const [vitall_patient_id, account_id = ''] = [
    activeProfile?.vitall_patient_id ?? '',
    activeProfile?.account_id,
  ];
  const { name: code } = setting;

  const metric = getObservationConfig(code);
  const [deleteAlertSetting] = useDeleteAlertSetting();

  const deleteSetting = async (alert_setting_id: string) => {
    await deleteAlertSetting({
      alert_setting_id,
      vitall_patient_id,
      account_id,
    });
  };

  return (
    <CardHeader
      action={
        flags.isAlertSettingDeleteAlertSettingEnabled ? (
          <ConfirmationDialog
            onConfirm={() => deleteSetting(setting.alert_setting_id)}
            persistent
            title={formatMessage(messages.delete)}
          >
            {({ handleOpen }) => (
              <Icon
                color="text.secondary"
                name="trash"
                onClick={handleOpen}
                type="fas"
              />
            )}
          </ConfirmationDialog>
        ) : undefined
      }
      avatar={
        <StackedIcon
          icons={
            metric?.icon.map((i) => ({
              ...i,
              color: 'primary.main',
              type: 'fad',
              size: 'lg',
            })) ?? []
          }
        />
      }
      title={
        <Typography variant="h6">
          {metric ? formatMessage({ id: metric.messageId }) : ''}
        </Typography>
      }
      /*
        <Button
          color="info"
          onClick={() => navigate(`${RECORDS}${category}/${code}`)}
          sx={{
            textTransform: 'capitalize',
            textDecoration: 'underline',
          }}
          variant="text"
        >
          {metric ? formatMessage({ id: metric.messageId }) : ''}
        </Button>
      */
    />
  );
}
